var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#6461FC",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3016_28285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4409 10.5253C17.5546 9.08187 15.5386 6.66016 12.0003 6.66016C8.46202 6.66016 6.44602 9.08187 5.55974 10.5253C5.28575 10.9684 5.14062 11.4792 5.14062 12.0002C5.14062 12.5212 5.28575 13.0319 5.55974 13.475C6.44602 14.9184 8.46202 17.3402 12.0003 17.3402C15.5386 17.3402 17.5546 14.9184 18.4409 13.475C18.7149 13.0319 18.86 12.5212 18.86 12.0002C18.86 11.4792 18.7149 10.9684 18.4409 10.5253ZM17.4666 12.8767C16.7054 14.1144 14.9826 16.1973 12.0003 16.1973C9.01802 16.1973 7.29517 14.1144 6.53402 12.8767C6.37124 12.6133 6.28502 12.3098 6.28502 12.0002C6.28502 11.6905 6.37124 11.387 6.53402 11.1236C7.29517 9.88587 9.01802 7.80301 12.0003 7.80301C14.9826 7.80301 16.7054 9.88358 17.4666 11.1236C17.6294 11.387 17.7156 11.6905 17.7156 12.0002C17.7156 12.3098 17.6294 12.6133 17.4666 12.8767Z",
    fill: "#6461FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 9.14294C11.4346 9.14294 10.8822 9.31051 10.4124 9.62446C9.94252 9.93841 9.57632 10.3846 9.36007 10.9067C9.14382 11.4288 9.08724 12.0033 9.19748 12.5575C9.30772 13.1117 9.57984 13.6208 9.97942 14.0204C10.379 14.42 10.8881 14.6921 11.4423 14.8023C11.9966 14.9126 12.571 14.856 13.0931 14.6397C13.6152 14.4235 14.0614 14.0573 14.3753 13.5874C14.6893 13.1176 14.8569 12.5652 14.8569 12.0001C14.856 11.2426 14.5546 10.5164 14.019 9.98078C13.4834 9.44516 12.7572 9.14385 11.9997 9.14294ZM11.9997 13.7144C11.6607 13.7144 11.3292 13.6138 11.0473 13.4255C10.7654 13.2371 10.5457 12.9694 10.4159 12.6561C10.2862 12.3429 10.2522 11.9982 10.3184 11.6656C10.3845 11.3331 10.5478 11.0277 10.7875 10.7879C11.0273 10.5482 11.3327 10.3849 11.6653 10.3187C11.9978 10.2526 12.3425 10.2865 12.6558 10.4163C12.969 10.546 13.2367 10.7658 13.4251 11.0477C13.6135 11.3296 13.714 11.661 13.714 12.0001C13.714 12.4547 13.5334 12.8908 13.2119 13.2123C12.8904 13.5338 12.4544 13.7144 11.9997 13.7144Z",
    fill: "#6461FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3016_28285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(5.14258 5.14307)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.81abc5d5896d45f32c4eb884c8c86f88.svg";
export { ForwardRef as ReactComponent };